import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { Button, Col, Row } from 'react-bootstrap';

import { useAppSelector } from 'hooks';
import { SectionTitle } from 'components/UI';
import { isPatientArchived } from 'store/patient/reducer';

import Message from './Message';
import AddEditMessageModal from './Message/AddEditMessageModal';

interface IMessagesProps {
  messages: ICarePlanMessage[] | undefined;
  getCarePlan: any;
  carePlanTemplate?: ICarePlanTemplate;
}

const Messages = ({ messages, getCarePlan, carePlanTemplate }: IMessagesProps) => {
  const intl = useIntl();
  const [showAddModal, setShowAddModal] = useState(false);
  const [_messages, setMessages] = useState(messages || []);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';
  const _isPatientArchived = useAppSelector(isPatientArchived);
  const handleOpenAddModal = () => {
    setShowAddModal(true);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };
  const handleAddMessage = () => {
    handleCloseAddModal();
    getCarePlan();
  };
  const handleEditMessage = () => {
    getCarePlan();
  };
  const onDeleteMessage = (id: string) => {
    setMessages(_messages.filter((elem) => elem.id !== id));
  };

  useEffect(() => {
    setMessages(messages || []);
  }, [messages]);

  return (
    <div className="mb-5">
      <div className="d-flex justify-content-between align-items-center">
        <SectionTitle
          dataTestId="careplan-messages-title"
          label={intl.formatMessage({ id: 'messagesKey' })}
          pill="APP"
        />
        {!isTemplateGlobal && (
          <Button
            variant="link"
            size="sm"
            onClick={handleOpenAddModal}
            data-test="careplan-messages-btn"
            disabled={_isPatientArchived}
          >
            + {intl.formatMessage({ id: 'messagesKey' })}
          </Button>
        )}
      </div>
      <Row>
        {_messages && _messages?.length > 0 ? (
          _messages.map((message, index) => (
            <Message
              dataTestId={`careplan-message-${index}`}
              message={message}
              key={message.id}
              handleEdit={handleEditMessage}
              onDelete={onDeleteMessage}
              carePlanTemplate={carePlanTemplate}
              disabled={_isPatientArchived}
            />
          ))
        ) : (
          <Col>
            <div
              className="bg-light text-center p-3 font-weight-bolder"
              data-test="careplan-messages-empty"
            >
              {intl.formatMessage({ id: 'noMessagesScheduled' })}
            </div>
          </Col>
        )}
      </Row>

      {showAddModal && (
        <AddEditMessageModal
          show={showAddModal}
          handleClose={handleCloseAddModal}
          handleEdit={handleAddMessage}
          carePlanTemplate={carePlanTemplate}
        />
      )}
    </div>
  );
};

export default Messages;
